const npmConf = require('npm-conf');

export default npmConf;
